import { Container, Flex, Paper, Text, Title } from "@mantine/core";

export default function PasswordTokenInvalid() {
  return (
    <Container fluid mt="4rem">
      <Flex justify="center">
        <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
          <Title order={4}>Ungültiger Link</Title>
          <Text>
            Der Link zum Zurücksetzen ihres Passworts ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an, um ihr Passwort
            zurückzusetzen.
          </Text>
        </Paper>
      </Flex>
    </Container>
  );
}
